import { useCustomForm } from "common/hooks/src/api/useCustomForm";
import { Button } from "components/button";
import { CardWithTitle } from "components/card/CardWithTitle";
import { InputField } from "components/fields/InputField";
import { useCreateArticle } from "modules/article/api";
import { CreateArticlePayload } from "modules/article/types/article.interface";
import { FormEvent } from "react";
import "react-datepicker/dist/react-datepicker.css";

const CreateArticle = () => {
  const { mutate } = useCreateArticle();
  const { formValues, setFormValues } = useCustomForm<CreateArticlePayload>({
    label: "",
    description: "",
    priceHT: 0,
    priceTTC: 0,
    type: "",
    cerfa: false,
  });

  const isSubmitDisabled =
    !formValues.label;

  const handleSubmit = (e: FormEvent) => {
    if (isSubmitDisabled) return;

    e.preventDefault();

    mutate({
      ...formValues,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <CardWithTitle title="Information de l'article">
        <div className="grid grid-cols-2 gap-5">
          <InputField
            variant="auth"
            extra="mb-3"
            label="Label*"
            placeholder="Manque Fluide"
            id="label"
            type="text"
            value={formValues.label}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                label: e.target.value,
              })
            }
          />
          <InputField
            variant="auth"
            extra="mb-3"
            label="Type*"
            placeholder="Service"
            id="type"
            type="text"
            value={formValues.type}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                type: e.target.value,
              })
            }
          />
          <div className="col-span-2">
            <InputField
              variant="auth"
              extra="mb-3"
              label="Description"
              placeholder="Description de l'article..."
              id="description"
              type="text"
              value={formValues.description}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  description: e.target.value,
                })
              }
            />
          </div>
          <InputField
            variant="auth"
            extra="mb-3"
            label="Prix HT*"
            placeholder="100"
            id="priceHT"
            type="number"
            value={formValues.priceHT}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                priceHT: parseFloat(e.target.value),
              })
            }
          />
          <InputField
            variant="auth"
            extra="mb-3"
            label="Prix TTC*"
            placeholder="120"
            id="priceTTC"
            type="number"
            value={formValues.priceTTC}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                priceTTC: parseFloat(e.target.value),
              })
            }
          />
          <div className="flex items-center mt-3">
            <input
              type="checkbox"
              id="cerfa"
              checked={formValues.cerfa}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  cerfa: e.target.checked,
                })
              }
            />
            <label htmlFor="cerfa" className="ml-2">
              Un Cerfa est requis pour l'article
            </label>
          </div>
        </div>
      </CardWithTitle>
      <div className="mt-2 flex w-full justify-end">
        <div className="w-full max-w-xs">
          <Button onClick={handleSubmit} disabled={isSubmitDisabled}>
            Ajouter l'article
          </Button>
        </div>
      </div>
    </form>
  );
};

export default CreateArticle;
